<template>
	<notivue
		v-slot="item"
		class="custom-toasts"
	>
		<notifications :item="item" />
	</notivue>
</template>

<script setup lang="ts">
import { Notivue, Notifications } from 'notivue';
</script>

<style lang="scss">
.custom-toasts .Notivue {
	&__notification {
		min-width: 24rem;
		background-color: $primary;

		&[data-notivue='success'] {
			background-color: $success;
		}

		&[data-notivue='error'] {
			background-color: $error;
		}
	}

	&__icon {
		display: none;
	}

	&__content {
		padding: 1rem;
	}

	&__content-title {
		color: white;
		font-size: 1.3rem;
	}

	&__content-message {
		color: white;
		font-size: 1.3rem;
	}

	&__close {
		position: absolute;
		width: 100%;
		height: 100%;
	}

	&__close-icon {
		display: none;
	}
}
</style>
